import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "funding-actions-triggers__title" }
const _hoisted_2 = { class: "funding-actions-triggers__title" }
const _hoisted_3 = { class: "funding-actions-triggers__title" }
const _hoisted_4 = {
  key: 1,
  class: "funding-actions-triggers funding-actions-triggers--short"
}

import { type PropType } from 'vue';
import { useRouter, useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'FundingActionsTriggers',
  props: {
  closeMenu: { type: Function as PropType<() => void>, default: () => {} },
  showDepositWithdraw: { type: Boolean, default: true },
  showDepositOnly: { type: Boolean, default: false },
  short: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props;

const router = useRouter();
const route = useRoute();

const navigateTo = ({ hash }: { hash: string }) => {
  router.push({
    ...route,
    hash: `#${hash}`,
  });
};

const fundingActionsTriggered = (action: 'Deposit' | 'Withdraw' | 'Transfer') => {
  props.closeMenu();
  navigateTo({ hash: action });
};

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!
  const _component_x_button = _resolveComponent("x-button")!

  return (!__props.short)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['funding-actions-triggers funding-actions-triggers--large', { 'funding-actions-triggers--deposit-only': __props.showDepositOnly }])
      }, [
        (__props.showDepositWithdraw || __props.showDepositOnly)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_x_button, {
                id: "deposit-trigger",
                block: true,
                size: "xs",
                variant: "success",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (fundingActionsTriggered('Deposit')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ot_icon, {
                    class: "funding-actions-triggers__icon",
                    name: "received"
                  }),
                  _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('fundamentals.addFunds')), 1)
                ]),
                _: 1
              }),
              (__props.showDepositWithdraw)
                ? (_openBlock(), _createBlock(_component_x_button, {
                    key: 0,
                    id: "withdraw-trigger",
                    block: true,
                    size: "xs",
                    variant: "tertiary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (fundingActionsTriggered('Withdraw')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ot_icon, {
                        class: "funding-actions-triggers__icon",
                        name: "send"
                      }),
                      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('fundamentals.withdraw')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (!__props.showDepositOnly)
          ? (_openBlock(), _createBlock(_component_x_button, {
              key: 1,
              id: "transfer-trigger",
              block: true,
              size: "xs",
              variant: "tertiary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (fundingActionsTriggered('Transfer')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ot_icon, {
                  class: "funding-actions-triggers__icon",
                  name: "arrow-swap-horizontal"
                }),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('fundamentals.transfer')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ], 2))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createVNode(_component_x_button, {
          id: "deposit-trigger",
          variant: "success",
          size: "sm",
          text: _ctx.$t('fundamentals.addFunds'),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (fundingActionsTriggered('Deposit')))
        }, null, 8, ["text"]),
        _createVNode(_component_x_button, {
          id: "withdraw-trigger",
          class: "funding-actions-triggers__withdraw-transfer-button",
          variant: "tertiary",
          size: "3xs",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (fundingActionsTriggered('Withdraw')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ot_icon, {
              class: "funding-actions-triggers__withdraw-transfer-icon",
              name: "send"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_x_button, {
          id: "transfer-trigger",
          class: "funding-actions-triggers__withdraw-transfer-button",
          variant: "tertiary",
          size: "3xs",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (fundingActionsTriggered('Transfer')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ot_icon, {
              class: "funding-actions-triggers__withdraw-transfer-icon",
              name: "arrow-swap-horizontal"
            })
          ]),
          _: 1
        })
      ]))
}
}

})